<template>
  <div class="field-subtext">
    {{ $t("query_editor_help_button.editor_subtext") }}
    <a
      class="bold block"
      :href="appConfig.urls.learnMore"
      rel="noopener noreferrer"
      target="_blank"
    >
      {{ $t("query_editor_help_button.learn_more_button") }}
    </a>
  </div>
</template>

<script>
import { storeToRefs } from "pinia";

import { useGlobalStore } from "shared/stores/global";

export default {
  name: "QueryEditorHelpButton",
  setup() {
    const { appConfig } = storeToRefs(useGlobalStore());

    return { appConfig };
  },
};
</script>

<style lang="scss" scoped>
ul {
  list-style-type: none;
  padding-inline-start: 0;
}
</style>
